module.exports = __webpack_public_path__ + "img/505.7091e6c3.png";